import styles from './PurchaseTokensMessage.module.css';

interface IPurchaseTokensMessage {}

/** A component that shows a message saying the user needs to purchase tokens, previously this was part of the purchase tokens UI */
const PurchaseTokensMessage = (_props: IPurchaseTokensMessage) => {
  return (
    <p className={styles.messageText}>
      You don’t have enough tokens for this option. Fingers crossed you'll
      collect some more tokens soon by matching numbers in our weekly draws! 🍀
    </p>
  );
};

export default PurchaseTokensMessage;
